import { Component } from '@angular/core';
import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ApplicationService } from './core/services/application/application.service';
import { AuthenticationService } from './core/services/authentication/authentication.service';
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet
  ]
})
export class AppComponent {
  title = 'alliance-syrexadmin';

  constructor(
    public authService: AuthenticationService,
    faIconLibrary: FaIconLibrary,
    faConfig: FaConfig,
    applicationService: ApplicationService) {
    faIconLibrary.addIconPacks(fas);
    faIconLibrary.addIconPacks(far);
    faConfig.defaultPrefix = 'fas';

    applicationService.darkThemeEnabled$.subscribe(enabled => {
      if (enabled) {
        document.body.classList.add('dark-theme');
      } else {
        document.body.classList.remove('dark-theme');
      }
    });
  }
}
